var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 780.26719,
    height: 776.73528,
    viewBox: "0 0 780.26719 776.73528",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .fnieufbhrieb {\r\n        fill: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -364.40002,
    y1: 515.14863,
    x2: -364.40002,
    y2: 496.20263,
    gradientTransform: "translate(14976.00098 -19726.46518) scale(40 39.7778)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0062e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19afff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fnieufbhrieb",
    d: "M337.57839,785.95726V510.91236H240.045V401.67543h97.5334V315.84556c0-97.5334,62.42161-152.15187,152.15186-152.15187,27.30983,0,58.52,3.90158,85.82987,7.80315v99.48359H524.84323c-46.81651,0-58.52,23.40826-58.52,54.61847v76.07653H569.70835L552.15186,510.91236H466.32319v275.0449l.02,1.59232C651.65665,754.388,790.1336,594.792,790.1336,401.67543c0-214.57348-175.56012-390.1336-390.1336-390.1336S9.8664,187.10195,9.8664,401.67543c0,193.1166,142.38848,353.44008,327.70194,386.60168Z",
    transform: "translate(-9.8664 -11.54183)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook-logo.ccb71ba2ff6bfe22547e7356dab0a60d.svg";
export { ForwardRef as ReactComponent };